import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      {/* main footer */}
      <footer className="boxcar-footer footer-style-one cus-st-1">
        <div className="footer-top">
          <div className="boxcar-container">
            <div className="right-box">
              <div className="top-left wow fadeInUp">
                <h6 className="title">Join Car Junction</h6>
                <div className="text">
                  Receive pricing updates, shopping tips &amp; more!
                </div>
              </div>
              {/* <div
                className="subscribe-form wow fadeInUp"
                data-wow-delay="100ms"
              >
                <form method="post" action="#">
                  <div className="form-group">
                    <input
                      type="email"
                      style={{color:"white"}}
                      name="email"
                      className="email"
                      placeholder="Your e-mail address"
                    />
                    <button
                      type="button"
                      className="theme-btn btn-style-one hover-light"
                    >
                      <span className="btn-title">Sign Up</span>
                    </button>
                  </div>
                </form>
              </div> */}
            </div>
          </div>
        </div>
        <div className="widgets-section items-center">
          <div className="boxcar-container">
            <div className="row">
              {/* Footer COlumn */}
              <div className="footer-column-two col-lg-9 col-md-12 col-sm-12">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="footer-widget links-widget wow fadeInUp">
                      <h4 className="widget-title">Useful Links</h4>
                      <div className="widget-content">
                        <ul className="user-links style-two">
                          <li>
                            <Link to={'/About'} >About Us</Link>
                          </li>
                          <li>
                            <Link to={'/Inventory'} >Inventory</Link>
                          </li>
                          <li>
                            <Link to={'/FAQ'} >FAQs</Link>
                          </li>
                          <li>
                            <Link to={'/Contact'} >Contact Us</Link>
                          </li>
                          <li>
                            <Link to={'/'} >Home</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div
                      className="footer-widget links-widget wow fadeInUp"
                      data-wow-delay="100ms"
                    >
                      <h4 className="widget-title">Quick Links</h4>
                      <div className="widget-content">
                        <ul className="user-links style-two">
                          <li>
                            <Link to={'/Contact'} >Get in Touch</Link>
                          </li>
                          <li>
                            <Link to={'/About'} >About Us</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div
                      className="footer-widget links-widget wow fadeInUp"
                      data-wow-delay="300ms"
                    >
                      <h4 className="widget-title">Vehicles Type</h4>
                      <div className="widget-content">
                        <ul className="user-links style-two">
                          <li>
                            <a >SUV</a>
                          </li>
                          <li>
                            <a >Sedan</a>
                          </li>
                          <li>
                            <a >Hatchbacks</a>
                          </li>
                          <li>
                            <a >Convertible</a>
                          </li>
                          
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer column */}
              <div className="footer-column col-lg-3 col-md-12 col-sm-12">
                <div
                  className="footer-widget social-widget wow text-center fadeInUp"
                  data-wow-delay="400ms"
                >
                  <div className="widget-content">
                    <div className="social-icons">
                      <h6 className="title">Connect With Us</h6>
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin-in" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  Footer Bottom */}
        <div className="footer-bottom">
          <div className="boxcar-container">
            <div className="inner-container">
              <div className="copyright-text wow fadeInUp">
                © <a href="#">2026 carjunction.ca. All rights reserved.</a>
              </div>
              <ul className="footer-nav wow fadeInUp" data-wow-delay="200ms">
                <li>
                  <a href="#">Terms &amp; Conditions</a>
                </li>
                <li>
                  <a href="#">Privacy Notice</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* End boxcar-footer */}
    </div>
  );
};

export default Footer;
